"use client";
//#region src/dialog/utils/orchestrate.ts
const cleanups = /* @__PURE__ */ new WeakMap();
function flushCleanupStack(elementCleanups, key, stack) {
	while (stack.length) {
		const entry = stack[stack.length - 1];
		if (!entry) {
			elementCleanups.delete(key);
			return;
		}
		if (!entry.disposed) return;
		stack.pop();
		entry.cleanup();
	}
	elementCleanups.delete(key);
}
function orchestrate(element, key, setup) {
	let elementCleanups = cleanups.get(element);
	if (!elementCleanups) {
		elementCleanups = /* @__PURE__ */ new Map();
		cleanups.set(element, elementCleanups);
	}
	const stack = elementCleanups.get(key) ?? [];
	const entry = {
		cleanup: setup(),
		disposed: false
	};
	if (!stack.length) elementCleanups.set(key, stack);
	stack.push(entry);
	return () => {
		if (!stack.includes(entry)) return;
		entry.disposed = true;
		flushCleanupStack(elementCleanups, key, stack);
	};
}
function setAttribute(element, attr, value) {
	const setup = () => {
		const previousValue = element.getAttribute(attr);
		element.setAttribute(attr, value);
		return () => {
			if (previousValue == null) element.removeAttribute(attr);
			else element.setAttribute(attr, previousValue);
		};
	};
	return orchestrate(element, attr, setup);
}
function setProperty(element, property, value) {
	const setup = () => {
		const exists = property in element;
		const previousValue = element[property];
		element[property] = value;
		return () => {
			if (!exists) delete element[property];
			else element[property] = previousValue;
		};
	};
	return orchestrate(element, property, setup);
}
function assignStyle(element, style) {
	if (!element) return () => {};
	const setup = () => {
		const prevStyle = element.style.cssText;
		Object.assign(element.style, style);
		return () => {
			element.style.cssText = prevStyle;
		};
	};
	return orchestrate(element, "style", setup);
}
function setCSSProperty(element, property, value) {
	if (!element) return () => {};
	const setup = () => {
		const previousValue = element.style.getPropertyValue(property);
		element.style.setProperty(property, value);
		return () => {
			if (previousValue) element.style.setProperty(property, previousValue);
			else element.style.removeProperty(property);
		};
	};
	return orchestrate(element, property, setup);
}
//#endregion
export { assignStyle, orchestrate, setAttribute, setCSSProperty, setProperty };

//# sourceMappingURL=orchestrate.js.map